<template>
  <v-row justify="space-around">
    <v-expansion-panels focusable
    :popout="true"
    :inset="true"
    :accordion="false"
    >
      <v-expansion-panel disable-icon-rotate="true">
        <v-expansion-panel-header>
          <b>Kullanıcı Soruları veya İstekleri</b>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-timeline dense>
            <v-timeline-item v-for="(question, index) in questions" :key="index">
              <span slot="opposite">Tus eu perfecto</span>
              <v-card class="elevation-2">
                <v-card-title class="headline">Email : {{question.email}}</v-card-title>
                  <v-card-text>
                    {{question.question}}<br>
                    Tarih = {{question.date}}<br><br>
                    <v-btn color="primary" @click="questionSolved(questions,index)">
                    <div style ="color:white"> Cevaplandı</div>
                    </v-btn>  
                  </v-card-text>
              </v-card>
            </v-timeline-item>
            <div v-if = "pagination">
              <v-pagination
              v-model="page"
              :circle="circle"
              :disabled="disabled"
              :length="length"
              :next-icon="nextIcon"
              :prev-icon="prevIcon"
              :page="page"
              @input="bringQuestions(page)"
              :total-visible="totalVisible"
              ></v-pagination>
            </div>  
          </v-timeline>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div v-if = "messageText">
          <h3 align="center">Görüntülenecek İstek veya Soru Bulunmamaktadır</h3>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>
<script>
export default {
    data(){
      return{
        circle: false,
        disabled: false,
        length: null,
        nextIcon: 'navigate_next',
        nextIcons: ['mdi-chevron-right', 'mdi-arrow-right', 'mdi-menu-right'],
        prevIcon: 'navigate_before',
        prevIcons: ['mdi-chevron-left', 'mdi-arrow-left', 'mdi-menu-left'],
        page: 1,
        totalVisible: 12,
        questions: null,
        messageText: false,
        pagination: true
        }
    },
    methods:{
        bringQuestions(){
            /*axios.post(`http://localhost:3000/bringquestions?page=${this.page}`,{})
            .then(res => {
              if(res.data.value.isValid == 0){
                this.messageText = true
                this.pagination = false
              }
              else{
                this.questions = res.data.value.value
                this.length = res.data.value.count
              }
            })
            .catch(function(error){
                console.log(error)
            })*/
        },
        questionSolved(questions,index){
            var removed = questions.splice(index,1);
            var questionId = removed[0]._id
            return questionId
            /*axios.post('http://localhost:3000/questionsolved',{
                questionId
            })
            .then(function(res){
                console.log(res)
            })
            .catch(function(error){
                console.log(error)
            });*/
        },
    },
    created(){
        this.bringQuestions();
    }
}
</script>